export default __webpack_public_path__ + "static/GraphikLCWeb-Regular-31d743ac79f43d13f5265412857f731d.woff2";